import { createSlice } from "@reduxjs/toolkit";
import { boardService } from "../../../services/board.service";

const initialState = {
  boards: [],
  filteredBoard: null,
  board: null,
  isBoardModalOpen: false,
  boardModalRoute: {
    boardId: null,
    groupId: null,
    taskId: null,
    desktopId: null,
    activityLog: null,
  },
  dynamicModalObj: { isOpen: false, pos: { x: "", y: "" }, type: "" },
  filter: boardService.getDefaultFilterBoard(),
  status: "idle",
  error: null,
  collapsedGroups: {},
  boardsLoading: false,
};

const boardReducer = createSlice({
  name: "board",
  initialState,
  reducers: {
    loadBoard: () => {
      return initialState;
    },

    setBoardsLoading: (state, action) => {
      state.boardsLoading = action.payload;
    },

    setBoards: (state, action) => {
      state.boards = action.payload.boards;
    },
    setBoard: (state, action) => {
      state.board = { ...action.payload.board };
    },
    setFilterBoard: (state, action) => {
      state.filteredBoard = { ...action.payload.filteredBoard };
    },
    removeBoard: (state, action) => {
      const boardId = action.payload.boardId;

      state.boards = state.boards.filter((b) => String(b._id) !== String(boardId));

      if (state.board?._id && String(state.board._id) === String(boardId)) {
        state.board = null;
      }

      if (state.filteredBoard?._id && String(state.filteredBoard._id) === String(boardId)) {
        state.filteredBoard = null;
      }

      if (state.selectedBoardId && String(state.selectedBoardId) === String(boardId)) {
        state.selectedBoardId = null;
      }
    },
    addBoard: (state, action) => {
      state.boards = [action.payload.board, ...state.boards];
    },
    updateBoard: (state, action) => {
      const next = action.payload.board;

      state.boards = state.boards.map((b) =>
        String(b._id) === String(next._id) ? next : b
      );

      if (state.board?._id && String(state.board._id) === String(next._id)) {
        state.board = next;
      }

      if (state.filteredBoard?._id && String(state.filteredBoard._id) === String(next._id)) {
        state.filteredBoard = next;
      }
    },

    setModal: (state, action) => {
      state.isBoardModalOpen = action.payload.isOpen;
    },
    setFilter: (state, action) => {
      state.filter = action.payload.filter;
    },
    setDynamicModal: (state, action) => {
      state.dynamicModalObj = action.payload.dynamicModalObj;
    },
    setDynamicWidth: (state, action) => {
      state.dynamicWidth = action.payload.dynamicWidth;
    },
    clearFilterDynamic: (state) => {
      state.filter.dynamic = {};
    },
    setSelectedBoardId: (state, action) => {
      state.selectedBoardId = action.payload.selectedBoardId;
    },
    resetSelectedBoardId: (state) => {
      state.board = null;
    },
    toggleGroupCollapse: (state, action) => {
      const groupId = action.payload;
      state.collapsedGroups[groupId] = !state.collapsedGroups[groupId];
    },
    setGroupCollapseState: (state, action) => {
      const { groupId, isOpen } = action.payload;
      state.collapsedGroups[groupId] = isOpen;
    },
    setBoardModalRoute: (state, action) => {
      state.boardModalRoute = {
        boardId: action.payload?.boardId || null,
        groupId: action.payload?.groupId || null,
        taskId: action.payload?.taskId || null,
        desktopId: action.payload?.desktopId || null,
        activityLog: action.payload?.activityLog || null,
      };
    },

    clearBoardModalRoute: (state) => {
      state.boardModalRoute = {
        boardId: null,
        groupId: null,
        taskId: null,
        desktopId: null,
        activityLog: null,
      };
    },
    clearBoards: () => initialState,
  }
});

// Exportando ações e o reducer
export const {
  loadBoard,
  setBoards,
  setBoard,
  setFilterBoard,
  removeBoard,
  addBoard,
  updateBoard,
  setModal,
  setFilter,
  setDynamicModal,
  setDynamicWidth,
  clearFilterDynamic,
  setSelectedBoardId,
  resetSelectedBoardId,
  toggleGroupCollapse,
  setGroupCollapseState,
  clearBoards,
  setBoardsLoading,
  setBoardModalRoute,
  clearBoardModalRoute,
} = boardReducer.actions;

export default boardReducer.reducer;
